const form_login = document.querySelector('.form-login');
const form_remember = document.querySelector('.form-remember');
const form_register = document.querySelector('.form-register');
const btn_remember = document.querySelector('.btn-remember');
const btn_register = document.querySelector('.btn-register-email');
const prev = document.querySelector('.login .prev');
const no_register = document.querySelector('.no-register');
const buttons = document.querySelector('.buttons-register');

btn_remember.addEventListener('click', ()=>{
    remember();
});

btn_register.addEventListener('click', ()=>{
    register();
});
prev.addEventListener('click', ()=>{
    back();
});

window.remember = () => {
    form_login.classList.add('d-none');
    no_register.classList.add('d-none');
    buttons.classList.add('d-none');
    form_remember.classList.remove('d-none');
    prev.classList.remove('d-none');
}

window.register = () => {
    form_login.classList.add('d-none');
    no_register.classList.add('d-none');
    buttons.classList.add('d-none');
    form_register.classList.remove('d-none');
    prev.classList.remove('d-none');
}

window.back = () => {
    form_remember.classList.add('d-none');
    form_register.classList.add('d-none');
    prev.classList.add('d-none');
    form_login.classList.remove('d-none');
    no_register.classList.remove('d-none');
    buttons.classList.remove('d-none');
}

window.addEventListener('click-remember', () => {
    remember();
})

window.addEventListener('click-register', () => {
    register();
})

window.addEventListener('click-back', () => {
    back();
})